import { Box, Button, Divider } from "@mui/material";

const ActionButtons = ({
    checkedPages,
    handleAddPageOpen,
    handleCreatePresetOpen,
}) => {
    return (
        <Box className="pagesActionsButtonsContainer">
            {checkedPages.length ? (
                <Button
                    id="savePresetButton"
                    className="createPresetButton"
                    variant="outlined"
                    color="secondary"
                    onClick={handleCreatePresetOpen}
                >
                    SAVE PRESET
                </Button>
            ) : null}
            <Button
                id="addPageButton"
                className="addPageButton"
                variant="contained"
                color="secondary"
                onClick={handleAddPageOpen}
            >
                ADD PAGE
            </Button>
            {/* <Divider orientation="vertical" flexItem/> */}
            {/* <DropdownUIScanButton
        title={checkedPages.length ? `UI SCAN (${checkedPages.length})` : "UI SCAN (ALL)" }
        handleScanPages={handleScanPages}
        presetsList={presetsList}
        checkedPages={checkedPages}
        handleEditPresetOpen={handleEditPresetOpen}
      /> */}
            {/* <Divider orientation="vertical" flexItem/>
      <DropdownTestCasesButton
        title={checkedPages.length ? `GENERATE TEST CASES (${checkedPages.length})` : "GENERATE TEST CASES (ALL)" }
        handleGenerateTestCases={handleGenerateTestCases}
        presetsList={presetsList}
        checkedPages={checkedPages}
        handleEditPresetOpen={handleEditPresetOpen}
        setGenerateTestCasesForAllPagesOpen={setGenerateTestCasesForAllPagesOpen}
      /> */}
            <Divider orientation="vertical" flexItem />
        </Box>
    );
};

export default ActionButtons;
